/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "{F1DDE54C-E908-446E-99E5-2BA9A86DCB18}",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://www.adityabirlacapital.com",
config.jssAppName = process.env.REACT_APP_JSS_APP_NAME || "ABCD",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/items/web",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://www.adityabirlacapital.com/sitecore/api/graph/items/web",
module.exports = config;